import { CognitoUserPool } from 'amazon-cognito-identity-js';

const poolData = {
    UserPoolId: 'us-east-1_6um0ktX6F',
    ClientId: '6dioaoqqqvm53626gk1eqci8cb'
}

export default new CognitoUserPool(poolData);